var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function SocialShare(el) {
  var $el = $(el),
      $popup = $el.find('.share__popup'),
      $permalink = $el.find('.js-permalink-copy');

  // Toggle permalink popup
  $el.on('click', '.js-permalink-popup', function(e) {
    e.preventDefault();
    $popup.fadeIn();
  }).on('click', '.js-popup-close', function(e) {
    e.preventDefault();
    $popup.fadeOut().find('small').text('');
  });

  // Copy permalink
  $permalink.on('click', function(e) {
    e.preventDefault();
    $popup.find('input').select();
    try {
      var successful = document.execCommand('copy');
      if (successful) {
        setTimeout(function(){
          $popup.find('small').text('Copied to clipboard');
          setTimeout(function(){
            $popup.fadeOut().find('small').text('');
          }, 2000);
        }, 200);
      }
    } catch (err) { }
  });

}

module.exports = SocialShare;
